import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Icon, IconName } from '@node-space/ui-components'

type CustomersDashboardSummaryItem = {
  icon: IconName
  labelKey: string
  value: number
}

export const CustomersDashboardSummary = ({
  totalCustomersOnboarded,
  totalCustomersTransacting,
}: {
  totalCustomersOnboarded: number
  totalCustomersTransacting?: number
}) => {
  const { t } = useTranslation()

  const summaryItems: CustomersDashboardSummaryItem[] = [
    {
      icon: 'CheckCircle',
      labelKey: 'embeddedCustomers.dashboard.totalCustomersVerified',
      value: totalCustomersOnboarded,
    },
    ...(totalCustomersTransacting
      ? [
          {
            icon: 'CoinArrowInCustom' as IconName,
            labelKey: 'embeddedCustomers.dashboard.totalCustomersTransacting',
            value: totalCustomersTransacting,
          },
        ]
      : []),
  ] as const

  return (
    <Box className="pb-10">
      <Box flex align="start" gap={60}>
        {summaryItems.map(item => (
          <Box key={item.labelKey} className="flex justify-between" gap={8}>
            <Box
              flex
              align="center"
              justify="center"
              className="rounded-full bg-surface-status-info w-12 h-12"
            >
              <Icon name={item.icon} size="large" />
            </Box>
            <Box>
              <p className="text-body-regular text-foreground-subdued">{t(item.labelKey)}</p>
              <p className="text-h3 text-foreground-subdued">{item.value}</p>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
